import React from 'react';

export const Pudo = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='34'
            height='34'
            viewBox='0 0 34 34'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M25.4 24.1999L25.4 7.3999M25.4 7.3999L19.4 14.8666M25.4 7.3999L31.4 14.8666M8.59998 9.8V26.6M8.59998 26.6L14.6 19.1333M8.59998 26.6L2.59998 19.1333'
                stroke='currentColor'
                strokeWidth='3.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default Pudo;
